export default __webpack_public_path__ + "static/media/abstract-shapes-20.b464306f.svg";